export const RitaRefTablesTypesAll = ['delta_i', 'delta_e', 'delta_t', 'common'];

export const EuRefTablesTypesAll = ['common', 'delta_t'];

export const RITA_REF_CACHE_NAMES_BY_TYPE = {
  delta_i: 'rita_delta_i',
  delta_e: 'rita_delta_e',
  delta_t: 'rita_delta_t',
  common: 'rita_common'
};

export const EU_REF_CACHE_NAMES_BY_TYPE = {
  delta_t: 'eu_ref_delta_t',
  common: 'eu_ref_common'
};

